import { z } from 'zod/v4';

export const BulkUpdateImpactAreaItemSchema = z.object({
  id: z.string().min(1),
  impactAreaId: z.string().min(1),
});

export const BulkUpdateImpactAreaRequestSchema = z
  .array(BulkUpdateImpactAreaItemSchema)
  .min(1);

export type BulkUpdateImpactAreaRequest = z.infer<
  typeof BulkUpdateImpactAreaRequestSchema
>;

export const BulkUpdateImpactAreaResponseSchema = z.object({
  updatedCount: z.number(),
  message: z.string(),
});

export type BulkUpdateImpactAreaResponse = z.infer<
  typeof BulkUpdateImpactAreaResponseSchema
>;
